import { Link } from 'react-router-dom';

export default function Footer() {
  const quickLinks = [
    { to: '/', label: '首页推荐' },
    { to: '/category/romance', label: '恋爱甜宠' },
    { to: '/category/action', label: '热血动作' },
    { to: '/category/fantasy', label: '奇幻冒险' },
    { to: '/about', label: '关于我们' },
  ];

  const socialLinks = [
    { icon: 'ri-home-4-line', label: '首页', to: '/' },
    { icon: 'ri-stack-line', label: '分类', to: '/category/romance' },
    { icon: 'ri-information-line', label: '关于我们', to: '/about' },
  ];

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="font-heading text-2xl font-bold text-background-50">韩漫之家</span>
            </Link>
            <p className="mt-4 text-sm text-foreground-300 leading-relaxed">
              免费韩漫 · 下拉式阅读 · 高清体验<br />
              致力于为您提供最优质的韩国漫画在线阅读服务
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">关注我们</h4>
            <ul className="flex flex-col gap-3">
              {socialLinks.map((social) => (
                <li key={social.label}>
                  <Link
                    to={social.to}
                    className="flex items-center gap-2.5 text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={`${social.icon} text-base`}></i>
                    </span>
                    {social.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h4>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              有任何问题或建议，欢迎随时联系我们的客服团队。
            </p>
            <div className="flex items-center gap-2 text-sm text-foreground-300">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line"></i>
              </span>
              <span>hello@dnchemical.com</span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 韩漫之家 HanMan Home. 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
